var _g, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSampleInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1152,
    height: 1024,
    viewBox: "0 0 1152 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M574.415 232.876h-528.602v-64h528.602v64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.014 628.438h-1057.202v-64h1057.202v64z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.014 1024h-1057.202v-64h1057.202v64z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M707.437 64c0-35.346 28.653-64 64-64h267.565c35.347 0 64 28.654 64 64v267.562c0 35.346-28.653 64-64 64h-267.565c-35.347 0-64-28.654-64-64v-267.562z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSampleInfo);
export default __webpack_public_path__ + "static/media/icon-sample-info.8811333e2bfe81f9bc31d7fa0844f4ef.svg";
export { ForwardRef as ReactComponent };